module.exports = __webpack_public_path__ + "static/media/adventskranz.f39f5f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/adventskranz.jpg
// module id = 113
// module chunks = 0